"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAttributeFilterButtonTotalCount = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var sdk_ui_1 = require("@gooddata/sdk-ui");
var AttributeFilterUtils_1 = require("../../utils/AttributeFilterUtils");
var json_stable_stringify_1 = tslib_1.__importDefault(require("json-stable-stringify"));
/**
 * Gets the number of the elements available for the attribute, depending on the inserted search
 * query.
 */
exports.useAttributeFilterButtonTotalCount = function (props) {
    var context = props.context, state = props.state, ownProps = props.ownProps;
    var validParentFilters = [];
    if (AttributeFilterUtils_1.isParentFilteringEnabled(context.backend)) {
        if (ownProps.parentFilters && !AttributeFilterUtils_1.isParentFiltersElementsByRef(ownProps.parentFilters)) {
            // eslint-disable-next-line no-console
            console.error("Parent filters must be defined by uris to enable parent-child filtering feature");
        }
        else {
            validParentFilters.push.apply(validParentFilters, AttributeFilterUtils_1.getValidElementsFilters(ownProps.parentFilters, ownProps.parentFilterOverAttribute));
        }
    }
    return sdk_ui_1.useCancelablePromise({
        promise: function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, AttributeFilterUtils_1.getElementTotalCount(context.workspace, context.backend, AttributeFilterUtils_1.getObjRef(context.filter, context.identifier), state.searchString, validParentFilters)];
            });
        }); },
    }, [
        context.backend,
        context.workspace,
        context.identifier,
        json_stable_stringify_1.default(ownProps.parentFilters),
        state.searchString,
        context.filter,
    ]);
};
//# sourceMappingURL=useAttributeFilterButtonTotalCount.js.map